/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, app: NonNullable<unknown> }} Meta_TitleInputs */



/**
* | output |
* | --- |
* | "{page} · {app}" |
*
* @param {Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_title = /** @type {((inputs: Meta_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.page} · ${i?.app}`)
	return /** @type {LocalizedString} */ (`${i?.page} · ${i?.app}`)
});